var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{ref:"wrapper",class:{
        [_vm.theme.wrapper]: true,
        [_vm.theme.active]: _vm.active,
    }},_vm._l((_vm.options),function(option){return _c('li',{key:`option-${option.name}`,on:{"click":function($event){return _vm.click(option.name)}}},[_c('i',{class:option.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }